export default __webpack_public_path__ + "static/media/Data_Games.372d08e2.jpg";